<template>
        <v-dialog v-model="controls.manifestDialog" max-width="800">
            <template v-slot:activator="{on}">
                <slot name="activator" :on="on">
                  <v-btn v-on="on" >Manifests</v-btn>
                </slot>
            </template>
            <v-card>
                <v-card-actions>
                    <div class="title">Existing Manifests</div>
                  <v-spacer></v-spacer>
                  <v-btn @click="getManifests" :disabled="controls.loadingManifests" icon><v-icon>refresh</v-icon></v-btn>
                  <v-spacer></v-spacer>
                  <Confirm @confirmed="deleteAllManifests">
                    <template v-slot:activator="{on}">
                      <v-btn v-on="on" color="error" :disabled="controls.loadingManifests">Delete All</v-btn>
                    </template>
                  </Confirm>
                </v-card-actions>
                <v-divider></v-divider>
                <v-dialog v-model="controls.createOrderFromManifest">
                    <v-card>
                        <v-card-text>
                            <CreateOrder :manifest="manifest"></CreateOrder>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <v-progress-linear v-if="controls.loadingManifests" indeterminate></v-progress-linear>
                <v-card-text>
                    <v-list v-if="queried.manifests">
                        <template v-for="(fest, index) in queried.manifests">
                            <v-list-item  :key="index">
                                <v-list-item-icon v-if="fest.manifest_data && (fest.manifest_data.status !== 'in-transit' && fest.manifest_data.status !== 'received')">
                                  <v-icon color="error">warning</v-icon>
                                  <span class="error--text">Not In-Transit</span>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                      {{ fest.id }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                      picked up: {{ fest.picked_up }} | received: {{ fest.received }} | has data: <span :class="fest.manifest_data && !fest.manifest_data.error ? 'green--text' : 'red--text'">{{ fest.manifest_data && !fest.manifest_data.error ? 'true' : 'false' }}</span>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle v-if="fest.manifest_data && fest.manifest_data.error">{{ fest.manifest_data.validation_messages }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <CreateFromManifest
                                        v-if="fest.manifest_data && !(fest.manifest_data.status !== 'in-transit' && fest.manifest_data.status !== 'received') && !fest.manifest_data.error"
                                        :manifest="fest"
                                        icon
                                    >
                                      <template v-slot:activator="{on}">
                                        <v-btn v-on="on" color="success" icon outlined><v-icon>add</v-icon></v-btn>
                                      </template>
                                    </CreateFromManifest>
<!--                                    <CaCreateOrder v-if="fest.manifest_data && !(fest.manifest_data.status !== 'in-transit' && fest.manifest_data.status !== 'received') && !fest.manifest_data.error" :manifest="fest.manifest_data" icon>-->
<!--                                      <template v-slot:activator="{on}">-->
<!--                                        <v-btn v-on="on" color="success" icon outlined><v-icon>add</v-icon></v-btn>-->
<!--                                      </template>-->
<!--                                    </CaCreateOrder>-->
                                    <v-tooltip v-else bottom>
                                        <template v-slot:activator="{on}">
                                            <v-btn
                                                    v-on="on"
                                                    color="primary"
                                                    icon
                                                    outlined
                                                    :loading="fest.loadingData"
                                                    @click="receiveManifest(fest)"
                                            >
                                                <v-icon>get_app</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Load manifest</span>
                                    </v-tooltip>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider :key="index+fest.id"></v-divider>
                        </template>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-dialog>
</template>

<script>
    //resources
    import trace from '../../Lib/Tracability'
    //components
    export default {
        name: "index",
        components:{
            CreateOrder: () => import('./Orders'),
            CaCreateOrder: () => import('./components/CreateOrder'),
            CreateFromManifest: () => import("@/views/orders/components/Manifest/CreateFromManifest")
        },
        data:() => ({
            controls:{
                manifestDialog: false,
                createOrder: false,
                createOrderFromManifest: false,
                loadingManifests: false,
                loadingManifest: false,
            },
            queried:{
                manifests: null,
            },
            manifest: null,
        }),
        created(){
          this.getManifests();
        },
        methods:{
            async getManifests(){
                this.controls.loadingManifests = true;
                let manifests = await this.$firestore.collection('manifests').get();
                this.queried.manifests = manifests.docs.map(manifest => {
                  return {
                    ...manifest.data(),
                    loadingData: false,
                    loadingOrder: false,
                    uid: manifest.id
                  }
                })
                this.controls.loadingManifests = false;
            },
            getManifestData(manifest){
                this.controls.loadingManifest  = true;
                this.controls.loadingManifest  = false;
                this.manifest = manifest;
                this.controls.createOrderFromManifest = true;
            },
            async receiveManifest(manifest){
                manifest.loadingData = true;
                try{
                    let response = await trace.get('/manifest/get/' + manifest.id);
                    await this.$firestore.collection('manifests').doc(manifest.uid).update({manifest_data: response.data, received: false}).then(() => {
                        manifest.loadingData = false;
                        this.getManifests();
                        this.$store.dispatch("showSuccess", "Manifest Message Loaded!")
                    }).catch(error => {
                        manifest.loadingData = false;
                        this.$store.dispatch("showError", "Failed to load manifest.")
                    })
                }catch(error){
                    manifest.loadingData = false;
                    this.$store.dispatch("showError", error);
                }

            },
            async parseManifestIdForCustomerId(manifest_id){
              let manifestExploded = manifest_id.split('.');
              let customerMme = manifestExploded[0].replace('/^WA/g', '');
              await this.$store.$db().model('licenses').api().fetch({
                where: {
                  key: "license",
                  value: customerMme
                }
              })
            },
            async deleteAllManifests(){
              this.controls.loadingManifests = true;
              let batch = this.$firestore.batch();
              for(let manifest of this.queried.manifests){
                let doc = this.$firestore.collection('manifests').doc(manifest.uid);
                batch.delete(doc);
              }
              await batch.commit();
              this.controls.loadingManifests = false;
              this.getManifests();
            }
        }
    }
</script>

<style scoped>

</style>
